var mediator = module.exports = Chaplin.mediator;
